import { F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface UnsavedChangesFormModalProps {
  isOpen: boolean
  onClose: () => void
  onSaveAndExit: () => void
  onExitWithoutSaving: () => void
  isSaving?: boolean
}

const UnsavedChangesFormModal = ({
  isOpen,
  onClose,
  onSaveAndExit,
  onExitWithoutSaving,
  isSaving = false,
}: UnsavedChangesFormModalProps) => {
  return (
    <F0Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={i18n.t('trainings.surveys.create.unsaved_changes_modal.title')}
      primaryAction={{
        label: i18n.t('trainings.surveys.create.unsaved_changes_modal.save_and_quit'),
        onClick: onSaveAndExit,
        loading: isSaving,
        disabled: isSaving,
      }}
      secondaryAction={{
        label: i18n.t('trainings.surveys.create.unsaved_changes_modal.quit_without_saving'),
        onClick: onExitWithoutSaving,
        disabled: isSaving,
      }}
    >
      {i18n.t('trainings.surveys.create.unsaved_changes_modal.description')}
    </F0Dialog>
  )
}

export default UnsavedChangesFormModal
